import isEmpty from 'lodash/isEmpty';
import { store } from '../../store';
import { URL_PATTERN } from '../../constants/validationPatterns';
import { retailerSettingsService } from '../retailer-settings/retailer-settings';
import { rawString } from '../../react-components/Language';

export const getItemEligibilityMsg = (item) => {
  const { language: lang } = store.getState();

  const product = retailerSettingsService.getProduct();
  const productToken = product.substr(0, product.length - 1);

  const itemEligibilities = item.item_eligibilities;
  const itemEligibilitiesMsgs = !isEmpty(itemEligibilities) && itemEligibilities[productToken];
  const eligibilityMsg = itemEligibilitiesMsgs
    ? lang[itemEligibilities[productToken].message_token] || itemEligibilities[productToken].message
    : item[`trans_${productToken}_eligible_msg`] || item[`${productToken}_eligibility_message`];

  // Check if the eligibilityMsg has URLs but doesn't contain HTML link tags
  if (
    eligibilityMsg &&
    eligibilityMsg.match(URL_PATTERN) &&
    !/<a\b[^>]*>(.*?)<\/a>/i.test(eligibilityMsg)
  ) {
    return eligibilityMsg.replaceAll(
      URL_PATTERN,
      (url) => `<a href="${url}" target="_blank">${url}</a>`,
    );
  }
  return eligibilityMsg;
};

export const displayEligibilityMessage = (item) => {
  const {
    page: { productType } = {},
    returnsSettings: { [productType]: { displayEligibilityMsg = false } = {} },
  } = store.getState();
  return displayEligibilityMsg ? getItemEligibilityMsg(item) : '';
};

export const getIneligibleQtyPath = (item) =>
  item?.current_event?.quantity > 0 ? `current_event.quantity` : 'remaining_qty';

export const getIneligibleMsg = (item) =>
  item?.current_event?.event_type?.status
    ? rawString({
        langKey: [
          `returns.step_1.item_level_grouping.status.${item.current_event.event_type.status}`,
        ],
      })
    : getItemEligibilityMsg(item);
